import { render } from "./HomeView.vue?vue&type=template&id=0c08d50f&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=0c08d50f&lang=less&scoped=true"

import exportComponent from "E:\\phpstudy_pro\\WWW\\szm-customer-crm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c08d50f"]])

export default __exports__